// Skinline: carrusel infinito de vídeos ("noria").
// Duplica los primeros y últimos vídeos a los lados; al llegar a una copia, salta sin animación
// a su vídeo real equivalente, así nunca se llega a un final. Los vídeos solo se reproducen cuando se ven.
(function () {
  function prepareVideo(video) {
    video.muted = true;
    video.loop = true;
    video.playsInline = true;
    video.setAttribute('playsinline', '');
    video.setAttribute('muted', '');
    video.removeAttribute('controls');
  }

  function init(carousel) {
    if (carousel.dataset.ready) return;
    carousel.dataset.ready = 'true';

    const track = carousel.querySelector('[data-skugc-track]');
    const real = Array.from(track.children);
    const count = real.length;

    track.querySelectorAll('video').forEach(prepareVideo);

    if (count > 1) {
      const clones = Math.min(2, count);
      const makeClone = (el) => {
        const c = el.cloneNode(true);
        c.setAttribute('aria-hidden', 'true');
        c.removeAttribute('data-shopify-editor-block');
        c.querySelectorAll('video').forEach(prepareVideo);
        return c;
      };
      real.slice(-clones).reverse().forEach((el) => track.prepend(makeClone(el)));
      real.slice(0, clones).forEach((el) => track.append(makeClone(el)));

      const slides = () => track.children;
      const step = () => slides()[1].offsetLeft - slides()[0].offsetLeft;
      const index = () => Math.round(track.scrollLeft / step());

      const jumpTo = (i) => {
        track.style.scrollSnapType = 'none';
        track.style.scrollBehavior = 'auto';
        track.scrollLeft = i * step();
        track.offsetHeight; // fuerza el repintado antes de reactivar el snap
        track.style.scrollSnapType = '';
        track.style.scrollBehavior = '';
      };

      const normalize = () => {
        const i = index();
        if (i < clones) jumpTo(i + count);
        else if (i >= clones + count) jumpTo(i - count);
      };

      requestAnimationFrame(() => jumpTo(clones));

      // Solo recolocar si cambia el ancho (en móvil, la barra del navegador cambia la altura al hacer scroll)
      let lastWidth = track.clientWidth;
      let current = clones;
      track.addEventListener('scroll', () => (current = index()), { passive: true });
      window.addEventListener('resize', () => {
        if (track.clientWidth === lastWidth) return;
        lastWidth = track.clientWidth;
        jumpTo(clones + ((current - clones + count) % count));
      });

      let timer;
      const onScrollEnd = () => {
        clearTimeout(timer);
        timer = setTimeout(normalize, 120);
      };
      if ('onscrollend' in window) track.addEventListener('scrollend', normalize);
      else track.addEventListener('scroll', onScrollEnd, { passive: true });

      const move = (dir) => track.scrollBy({ left: dir * step(), behavior: 'smooth' });
      carousel.querySelector('[data-skugc-prev]')?.addEventListener('click', () => move(-1));
      carousel.querySelector('[data-skugc-next]')?.addEventListener('click', () => move(1));
    }

    // Reproducir solo los vídeos visibles (ahorra datos y batería)
    const videos = track.querySelectorAll('video');
    if (!videos.length) return;
    if (!('IntersectionObserver' in window)) {
      videos.forEach((v) => v.play().catch(() => {}));
      return;
    }
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const v = entry.target;
          if (entry.isIntersecting) {
            if (v.preload === 'none') v.preload = 'auto';
            v.play().catch(() => {});
          } else {
            v.pause();
          }
        });
      },
      { root: null, threshold: 0.25 }
    );
    videos.forEach((v) => observer.observe(v));
  }

  function initAll() {
    document.querySelectorAll('[data-skugc-carousel]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
